// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.5.233",
  "gitHash": "a1a25f6df4e8119bfc35ef4883f8dbb3a900fcfc",
  "versionWithHash": "5.5.233-a1a25f6df4e8119bfc35ef4883f8dbb3a900fcfc"
};
